export default __webpack_public_path__ + "static/media/img5.c2d60ab7.png";